import React, { useState, useCallback } from "react";
import _ from "lodash";
import { Button } from "reactstrap";

import Socket from "socket";
import CategoriesModal from "./CategoriesModal";
import logo from "assets/images/sbs/tot-new/tot-logo.png";
import guesser from "assets/images/sbs/tot-new/guesserr.png";
import youGuesser from "assets/images/sbs/tot-new/you-guesser.png";
import downArrow from "assets/images/sbs/tot-new/down-arrow.png";

const Guesser = ({ roomId, mobile_app, preguess_params }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [category, setCategory] = useState("");

  const handleToggleModal = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const text_1 = _.get(
    preguess_params,
    "text_1",
    "If the word is too tough, you can skip the word to move on."
  );
  const text_2 = _.get(
    preguess_params,
    "text_2",
    "Try to guess the word from the other player's clues!"
  );
  const instructions = _.get(
    preguess_params,
    "instructions",
    "Pick a category and start the round when ready!"
  );
  const categories = _.get(preguess_params, "categories", [
    "Sports",
    "Celebrities",
    "Musical Theater",
    "Disney",
    "Entertainment",
    "Everyday Life",
    "Travel",
    "Fun and Games",
    "Food and Drink",
    "Science and Technology",
    "Philosophy, Fables, Myths, and Legends",
    "Back in the Day"
  ]);
  const handleStart = () => {
    if (mobile_app) {
      const message = {
        action: "update-status",
        category
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "update-status",
        roomId,
        category
      };
      Socket.sendMessage(data);
    }
    setTimeout(() => {
      setCategory("");
    }, 2000);
  };
  return (
    <div className={`start-screen ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      <div className="text-center">
        <img src={logo} alt="logo" className="logo logo-tot" />
        <img src={guesser} alt="logo" />
        <div className="guesser-box">
          <img src={youGuesser} alt="guesser" className="you-guesser" />
          <ul>
            <li>{text_1}</li>
            <li>{text_2}</li>
          </ul>
          <p className="pick">{instructions}</p>
          <div className="category" onClick={() => setIsModalOpen(true)}>
            <p>{category !== "" ? category : "Category"}</p>
            <img src={downArrow} alt="" />
          </div>
        </div>
      </div>
      <Button className="start-btn" onClick={handleStart}>
        start
      </Button>
      {isModalOpen && (
        <CategoriesModal
          categories={categories}
          setCategory={setCategory}
          onCloseModal={handleToggleModal}
        />
      )}
    </div>
  );
};

export default Guesser;
